'use client';

import { useTranslations } from 'next-intl';
import React from 'react';

import { ContentWrapper } from '@/components/ContentWrapper';
import { Link } from '@/i18n/navigation';
import type { PageRachat } from '@/types/new-directus-types';

import {
  ContentSection,
  FaqSection,
} from '../../../contact/expertise-livre/components/ExpertisePageDetails/components';
import { useFaqState, useLocalizedContent } from './hooks';

interface RachatPageDetailsProps {
  pageData: PageRachat;
}

/**
 * Main component for rachat page details
 * Displays intro, CTA to expertise page, content, and FAQ sections
 */
export const RachatPageDetails: React.FC<RachatPageDetailsProps> = ({
  pageData,
}) => {
  const t = useTranslations('Pages.FormulaireDemandeExpertise');
  const { intro, contenu, faqData } = useLocalizedContent(pageData);
  const { openIndexes, toggleFaq } = useFaqState();

  return (
    <div className="space-y-8 bg-white">
      <ContentWrapper className="max-w-screen-md bg-white p-8 text-center">
        <ContentSection content={intro} />
      </ContentWrapper>

      <ContentWrapper className="max-w-screen-sm bg-white">
        <div className="flex justify-center py-4">
          <Link
            href="/contact/expertise-livre"
            className="btn btn-primary h-auto min-h-0 max-w-full whitespace-normal text-wrap px-6 py-4 text-center font-neutrifb text-base leading-snug text-white shadow-md transition-all hover:shadow-lg sm:px-10 sm:text-lg"
          >
            {t('bouton_faire_expertise')}
          </Link>
        </div>
      </ContentWrapper>

      <ContentWrapper className="max-w-screen-md bg-white p-8">
        <div className="space-y-12">
          <ContentSection content={contenu} />
          <FaqSection
            faqData={faqData}
            openIndexes={openIndexes}
            onToggle={toggleFaq}
          />
        </div>
      </ContentWrapper>
    </div>
  );
};
